import type { ForcedMovementDefenseCompileInput, ForcedMovementDefenseCompileResult, PresenceDefenseLayer } from '../types';
import { foldPresenceDefenseSources } from './presence-defense-source-fold';

const LAYERS: readonly PresenceDefenseLayer[] = ['force_move_resistance', 'immune_to_forced_movement'];

/** Plan replacement slots and root cleanup after source discovery and layer_has resolution. */
export function compileForcedMovementDefenseSlots(input: ForcedMovementDefenseCompileInput): ForcedMovementDefenseCompileResult {
    if (!input.isEncounterCreature && input.itemType !== 'creature' && input.itemType !== 'player_character') {
        return { processed: false, slots: {}, removedRootLayers: [] };
    }
    const slots: ForcedMovementDefenseCompileResult['slots'] = {};
    for (const layerName of LAYERS) {
        const layer = input.layers[layerName];
        // PHP tests the collected list before normalization; an empty metadata row
        // still suppresses transitional host fallback, then the writer discards it.
        const sources = layer.sources.length === 0 && layer.hasLayer
            ? [{ source_item_id: input.itemId, source_name: input.itemName ?? 'Creature', source_kind: input.itemType ?? 'creature' }]
            : layer.sources;
        const entries = foldPresenceDefenseSources({ layerName, initialEntries: [], sources });
        // Null requests deletion. No source must not leave a computed empty slot behind.
        slots[layerName] = entries.length > 0 ? entries : null;
    }
    return { processed: true, slots, removedRootLayers: [...LAYERS] };
}
